import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AlertCircle, Gift } from 'lucide-react';
import { publicApi } from '../utils/api';
import { IMG } from '../lib/images';

const ExitIntentBar = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setOpen(false);
    setStatus('');
  }, [location.pathname]);

  useEffect(() => {
    const hasSeen = localStorage.getItem('wowrolla_exit_seen');
    if (hasSeen) return;

    const onMouseOut = (event) => {
      if (event.clientY <= 10) {
        setOpen(true);
        localStorage.setItem('wowrolla_exit_seen', '1');
      }
    };

    document.addEventListener('mouseout', onMouseOut);
    return () => document.removeEventListener('mouseout', onMouseOut);
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus('');
    setSubmitting(true);
    try {
      await publicApi.submitLead({
        email,
        lead_type: 'exit_intent',
        source_page: location.pathname,
        note: 'Exit intent capture',
      });
      setStatus('Saved. We will send the AI Tool Buyer Checklist.');
      setEmail('');
    } catch {
      setStatus('Could not save right now.');
    } finally {
      setSubmitting(false);
    }
  };

  if (!open) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 25 }}
      animate={{ opacity: 1, y: 0 }}
      className="fixed bottom-3 left-3 right-3 md:left-auto md:right-4 md:w-[430px] z-[120]"
      data-testid="exit-intent-bar"
    >
      <div
        className="prime-glow-card p-4 border border-cyber-yellow/50 relative overflow-hidden"
        style={{ background: 'rgba(8,8,18,0.95)' }}
      >
        {/* Decorative background */}
        <div
          className="absolute inset-0 opacity-12"
          style={{
            backgroundImage: `url(${IMG.card.graphGrowth})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(rgba(8,8,18,0.88), rgba(8,8,18,0.92))' }} />
        <div className="absolute -right-10 -top-10 w-24 h-24 rounded-full bg-cyber-yellow/20 blur-2xl" />
        <div className="relative z-10">
        <p className="text-xs uppercase tracking-[0.16em] font-mono text-cyber-yellow mb-2 inline-flex items-center gap-2"><AlertCircle size={14} /> Before you leave</p>
        <h4 className="text-white font-semibold mb-1">Get the AI Tool Buyer Checklist</h4>
        <p className="text-xs text-text-secondary mb-3">Avoid hidden migration costs and choose a stack you can actually ship.</p>
        <form onSubmit={handleSubmit} className="flex gap-2">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="you@company.com"
            className="flex-1 px-3 py-2 bg-transparent border border-white/20 text-white"
          />
          <button type="submit" disabled={submitting} className="btn-primary text-sm">
            {submitting ? 'Saving...' : 'Send'}
          </button>
        </form>
        {status && <p className="text-xs mt-2 text-cyber-yellow">{status}</p>}
        <div className="mt-3 flex items-center justify-between text-xs text-text-muted">
          <Link to="/consulting" className="hover:text-cyber-yellow inline-flex items-center gap-1"><Gift size={13} /> Need help now? Book consulting</Link>
          <button onClick={() => setOpen(false)} type="button" className="hover:text-white">Dismiss</button>
        </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ExitIntentBar;

